import { useContext } from 'react';
import { IParticipantDotMenuContext, ParticipantDotMenuContext } from 'context';

export function useParticipantDotMenu(): IParticipantDotMenuContext {
  return useContext(ParticipantDotMenuContext)!;
}
